<div class="wrapper k-dflex">
  <h1 kendoTypography variant="h4">
    {{ "AUTH.EMAIL_CONFIRMATION" | translate }}
  </h1>

  <button kendoButton [primary]="true" routerLink="/auth/login" [fillMode]="'solid'">
    {{ "AUTH.LOGIN" | translate }}
  </button>
</div>
